import { TrackData } from '@inter/track'

const sendToNewRelic = (data: dataNewRelic) => TrackData.log(data)
const sendErrorToNewRelic = (data: dataNewRelic) => TrackData.error(data)

export { sendToNewRelic, sendErrorToNewRelic }
